import ExpertJourneysList from '@components/expert/ExpertJourneysList';
import ExpertTablesPage from '@components/pageTypes/ExpertTablesPage';
import useMyExpert from '@hooks/useMyExpert';

const ExpertAllJourneysPage = () => {
  const myExpert = useMyExpert();

  return (
    <ExpertTablesPage helmetKey="pageTitles.expert.allJourney.list">
      <ExpertJourneysList allJourneys expertId={myExpert?.id} myJourneys />
    </ExpertTablesPage>
  );
};

export default ExpertAllJourneysPage;
